<template>
  <div
    class="input-ui"
    :class="[
      size ? `input-ui--${size}` : '',
      {
        'input-ui--focus': isFocus && !disabled && !noEdit,
        'disabled': disabled,
        'completed': completed,
        'input-ui--no-edit': noEdit,
        'input-ui--show-clear': showBtnClear,
        'input-ui--no-label': !placeholder
      }, externalClass]"
  >
    <slot name="before" />
    <label>
      <span
        v-if="placeholder"
        hidden
      >
        {{ placeholder }}
      </span>
      <input
        ref="input"
        :type="type"
        :disabled="disabled || noEdit"
        :maxlength="maxLength"
        :value="value"
        :placeholder="isFocus ? placeholderInput : ''"
        v-bind="params"
        class="input-ui__input"
        @input="onInput($event.target.value)"
        @blur="onBlur"
        @focus="onFocus"
        @change="onChange($event.target.value)"
      >
    </label>
    <span
      v-if="placeholder"
      class="input-ui__label"
      :class="{'small': isFocus || value || value === 0}"
      @click="setInputFocus"
    >
      {{ placeholder }}
    </span>
    <slot name="after" />
    <button
      v-if="showBtnClear"
      type="button"
      class="input-ui__clear"
      tabindex="-1"
      @click="clearInput"
    >
      <Icon
        icon="r-close-window-rounded"
        class="input-ui__clear-icon"
      />
    </button>
  </div>
</template>

<script>
import Icon from './Icon.vue';
import '../../../../../svg-icons/r-close-window-rounded.svg';

export default {
  name       : 'InputUI',
  components : {
    Icon
  },

  props: {
    id: {
      type    : String,
      default : ''
    },

    type: {
      type    : String,
      default : 'text'
    },

    value: {
      type    : [String, Number],
      default : null
    },

    name: {
      type    : String,
      default : ''
    },

    autocomplete: {
      type    : String,
      default : ''
    },

    placeholder: {
      type    : String,
      default : ''
    },

    placeholderInput: {
      type    : String,
      default : ''
    },

    minLength: {
      type    : Number,
      default : null
    },

    maxLength: {
      type    : Number,
      default : null
    },

    disabled: {
      type    : Boolean,
      default : false
    },

    completed: {
      type    : Boolean,
      default : false
    },

    noEdit: {
      type    : Boolean,
      default : false
    },

    hideBtnClear: {
      type    : Boolean,
      default : false
    },

    required: {
      type    : Boolean,
      default : false
    },

    externalClass: {
      type    : String,
      default : ''
    },

    upperCaseText: {
      type    : Boolean,
      default : false
    },

    externalParams: {
      type    : Object,
      default : null
    },

    isPercent: {
      type    : Boolean,
      default : false
    },

    /**
     * @var {string} возможные значения: middle, small
     */
    size: {
      type    : String,
      default : ''
    }
  },

  emits: ['update:value', 'focus', 'blur', 'change-focus'],

  data() {
    return {
      isFocus      : false,
      showBtnClear : false,
      params       : {}
    };
  },

  watch: {
    isFocus(val) {
      this.$emit('change-focus', val);

      setTimeout(() => {
        this.setShowBtnClear();
      }, 200);
    },

    value(val, valOld) {
      if (this.isPercent) {
        if (val && parseFloat(val) > 100) {
          const resultVal = valOld && parseFloat(valOld) < 100 ? valOld : 100;

          this.$emit('update:value', resultVal);
          this.$emit('input', resultVal);
        } else if (val === '0') {
          this.$emit('update:value', '0');
          this.$emit('input', '0');
        }
      }
    }
  },

  mounted() {
    if (this.id) {
      this.params.id = this.id;
    }
    if (this.autocomplete) {
      this.params.autocomplete = this.autocomplete;
    }
    if (this.name) {
      this.params.name = this.name;
    }
    if (this.required) {
      this.params.required = 'required';
    }
    if (this.externalParams) {
      this.params = {
        ...this.params,
        ...this.externalParams
      };
    }
  },

  methods: {
    onInput(value) {
      if (this.disabled || this.noEdit) return;

      const resultVal = value && this.upperCaseText
        ? value.toUpperCase()
        : value;

      this.$emit('update:value', resultVal);
      this.$emit('input', resultVal);
    },
    onChange(value) {
      if (this.disabled || this.noEdit) return;

      const resultVal = value && this.upperCaseText
        ? value.toUpperCase()
        : value;

      this.$emit('change', resultVal);
    },
    setInputFocus() {
      if (this.disabled || this.noEdit) return;

      // Клик по лейбл
      this.isFocus = true;
      // * не ренеймить, $refs.input используется в загрузке чека
      this.$refs.input.focus();
    },
    onFocus() {
      if (this.disabled || this.noEdit) return;

      this.isFocus = true;
      this.$emit('focus');
    },
    onBlur() {
      if (this.disabled || this.noEdit) return;

      this.isFocus = false;
      setTimeout(() => {
        this.$emit('blur');
      }, 200);
    },
    clearInput() {
      this.$emit('update:value', '');
      this.$emit('input', '');
    },
    setShowBtnClear() {
      this.showBtnClear = this.isFocus && !this.hideBtnClear && !this.disabled && !this.noEdit;
    }
  }
};
</script>

<style scoped lang="scss" src="../../../../../css/redesign/components/common/input-ui.scss"></style>
